import React, { Component } from "react";
import global from "../../global.css";
import classes from "./PassengerRight.css";
import SignFirtOne from "../../assets/passengerRight.png";
import PassengerCooke from "../../assets/PassengerCooke.png";

class PassengerRight extends Component {
  state = {
    RightNowPart: 1
  };

  render() {
    return (
      <div className={classes.Background}>
        <div className={global.Responsive} onWheel={this.onMouseWheel}>
          <div className={classes.partOne}>
            <img
              src={SignFirtOne}
              alt="تصویر SIGN"
              className={classes.SignFirtOne}
            />
            <div>
              <h2>سیاست حفظ حریم خصوصی کاربران</h2>
              <p>
                ما متعهد می شویم که حریم خصوصی شما را حفظ کنیم و به آن احترام
                بگذاریم. ما حفظ امنیت اطلاعات شخصی شما را امری بسیار جدی و مهم
                می دانیم و در وب سایت خود از سیاستهای امنیتی و تکنولوژی هایی
                استفاده می کنیم که برای محافظت از اطلاعات شخصی طراحی شده اند.
                همچنین از روشها و دستورالعملهای امنیتی سختی که قوانین حفظ حریم
                خصوصی کاربران به آنها نیاز دارد، پیروی می کنیم.این روشهای
                محافظتی ذخیره سازی، استفاده و انتشار همه اطلاعات شما را دربر می
                گیرد و از دسترسی و استفاده غیر مجاز از این اطلاعات جلوگیری می
                کند. برای اینکه بتوانیم خدمات و محصولات خود را به شما ارائه
                کنیم، ممکن است به اطلاعات شما نیاز داشته باشیم. اگر شما از وب
                سایت ما استفاده می کنید باید اطلاعاتی را که ما نیاز داریم در
                اختیار ما قرار دهید و اگر نمی خواهید اطلاعات خود را به اشتراک
                بگذارید ممکن است قادر نباشید به وب سایت ما دسترسی داشته باشید و
                یا اینکه ممکن است نتوانید از بعضی بخشهای آن استفاده کنید.
              </p>
              <h3>استفاده از کوکی ها</h3>
              <p>
                کوکی ها فایلهای اطلاعاتی هستند که روی کامپیوتر شما ذخیره می شوند
                تا به وب سایتها کمک کنند که شما را بخاطر بیاورند. ما وهمکاران
                دیگر ما با استفاده از کوکی ها درباره نحوه استفاده شما از وب سایت
                ما اطلاعات جمع آوری می کنیم
              </p>
            </div>
          </div>
          <div className={[classes.partOne, classes.partdif].join(" ")}>
            <div>
              <h2>فعالیتهای مرورگر شما در هنگام بازدید از وب سایت</h2>
              <p>
                اگر شما از وب سایت محراب سیر کیش استفاده می کنید، کامپیوتر شما
                با استفاده از کوکی ها چند جستجوی آخر شما را ذخیره خواهد کرد .این
                کار به شما امکان میدهد که در هنگام استفاده مجدد از وب سایت
                محراب سیر کیش دوباره همان جستجوهای گذشته را تکرار کنید و یا
                اینکه بدون نیاز به دوباره وارد کردن اطلاعات، موضوعات دیگر را
                جستجو کنید.این اطلاعات فقط روی کامپیوتر شما ذخیره می شود .
                هنگامیکه شما از وب سایت محراب سیر کیش استفاده می کنید ما
                اطلاعاتی درباره فعالیتهای شما جمع آوری می کنیم که برخی از این
                اطلاعات عبارتند از: آدرس آی پی کامپیوتر شما، نوع مرورگری که شما
                استفاده می کنید (مرورگر برنامه ای است که شما برای دیدن وب سایتها
                از آن استفاده می کنید مانند اینترنت اکسپلورر، فایرفاکس، سافاری،
                گوگل کروم) زمانی که شما وارد وب سایت شده اید و مدت زمانی که از
                وب سایت استفاده کرده اید. URL مرجع شما (سایتی که شما برای دسترسی
                و ورود به وب سایت ما از آن استفاده کرده اید) ما با استفاده از
                این اطلاعات نمی توانیم شما را شناسایی کنیم. ما این اطلاعات را از
                بازدیدکنندگان بسیار زیاد سایتمان جمع آوری می کنیم و آنها را
                تحلیل می کنیم. ما با استفاده از این اطلاعات می توانیم بفهمیم که
                مردم چگونه از وب سایت ما استفاده می کنند و با فهمیدن این موضوع
                به ما کمک می کند خدمات بهتری به کاربران خود ارائه دهیم. ما ممکن
                است برخی آمار کاربران این وب سایت را به سازمانهای معتبر دیگرهم
                بدهیم اما اطلاعاتی که ما در اختیار این سازمانها قرار دهیم شامل
                جزئیات نمی شود وآنها نمی توانند با استفاده از این اطلاعات شما را
                شناسایی کنند.
              </p>
            </div>
            <img
              src={PassengerCooke}
              alt="تصویر SIGN"
              className={classes.SignFirtOne}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default PassengerRight;
